"use client";

import { c as _c } from "react/compiler-runtime";
import { fullScreenSupported } from "@/helpers/Helpers";
import { ArrowDownTrayIcon, ArrowTopRightOnSquareIcon, ArrowsPointingOutIcon, XMarkIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import type React from "react";
const BASE_BUTTON_CLASS = "tw-inline-flex tw-size-9 tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-text-iron-100 tw-transition tw-duration-200 desktop-hover:hover:tw-bg-iron-700 disabled:tw-cursor-default disabled:tw-opacity-60";
function ToolbarButton(t0) {
  const $ = _c(8);
  const {
    label,
    onClick,
    disabled: t1,
    children,
    className
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className) {
    t2 = clsx(BASE_BUTTON_CLASS, className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== disabled || $[4] !== label || $[5] !== onClick || $[6] !== t2) {
    t3 = <button type="button" aria-label={label} title={label} onClick={onClick} disabled={disabled} className={t2}>{children}</button>;
    $[2] = children;
    $[3] = disabled;
    $[4] = label;
    $[5] = onClick;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
const stopAndRun = (handler: () => void) => (event: React.MouseEvent<HTMLButtonElement>) => {
  event.stopPropagation();
  handler();
};
export function InlineMediaActions(t0) {
  const $ = _c(20);
  const {
    onDownload,
    onOpen,
    onFullscreen,
    openLabel,
    isDownloading,
    fullscreenTargetAvailable,
    variant,
    position: t1
  } = t0;
  const position = t1 === undefined ? "top-right" : t1;
  let t2;
  if ($[0] !== fullscreenTargetAvailable || $[1] !== onFullscreen || $[2] !== variant) {
    t2 = (variant === "image" || variant === "html") && Boolean(onFullscreen) && Boolean(fullscreenTargetAvailable) && fullScreenSupported();
    $[0] = fullscreenTargetAvailable;
    $[1] = onFullscreen;
    $[2] = variant;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const canFullscreen = t2;
  const positionClassName = position === "bottom-right" ? "tw-bottom-[5px] tw-right-[5px]" : "tw-right-[5px] tw-top-[5px]";
  let t3;
  if ($[4] !== positionClassName) {
    t3 = clsx("tw-absolute tw-z-30 tw-flex tw-overflow-hidden tw-rounded-lg tw-bg-iron-950/90 tw-shadow-lg tw-shadow-black/20 tw-ring-1 tw-ring-inset tw-ring-iron-700/60 tw-backdrop-blur", positionClassName);
    $[4] = positionClassName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== canFullscreen || $[7] !== onFullscreen) {
    t4 = canFullscreen && <ToolbarButton label="Full screen" onClick={stopAndRun(onFullscreen)}><ArrowsPointingOutIcon className="tw-size-4" aria-hidden="true" /></ToolbarButton>;
    $[6] = canFullscreen;
    $[7] = onFullscreen;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== onOpen || $[10] !== openLabel) {
    t5 = onOpen && openLabel && <ToolbarButton label={openLabel} onClick={stopAndRun(onOpen)}><ArrowTopRightOnSquareIcon className="tw-size-4" aria-hidden="true" /></ToolbarButton>;
    $[9] = onOpen;
    $[10] = openLabel;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isDownloading || $[13] !== onDownload) {
    t6 = onDownload && <ToolbarButton label={isDownloading ? "Downloading media" : "Download media"} onClick={stopAndRun(onDownload)} disabled={isDownloading}><ArrowDownTrayIcon className="tw-size-4" aria-hidden="true" /></ToolbarButton>;
    $[12] = isDownloading;
    $[13] = onDownload;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = <div className={t3}>{t4}{t5}{t6}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}
export function ExpandedMediaToolbar(t0) {
  const $ = _c(28);
  const {
    onOpen,
    onDownload,
    onFullscreen,
    onClose,
    openLabel,
    isDownloading,
    fullscreenTargetAvailable
  } = t0;
  let t1;
  if ($[0] !== fullscreenTargetAvailable || $[1] !== onFullscreen) {
    t1 = Boolean(onFullscreen) && Boolean(fullscreenTargetAvailable) && fullScreenSupported();
    $[0] = fullscreenTargetAvailable;
    $[1] = onFullscreen;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const canFullscreen = t1;
  let t2;
  if ($[3] !== canFullscreen || $[4] !== onFullscreen) {
    t2 = canFullscreen && <ToolbarButton label="Full screen" onClick={stopAndRun(onFullscreen)}><ArrowsPointingOutIcon className="tw-size-5" aria-hidden="true" /></ToolbarButton>;
    $[3] = canFullscreen;
    $[4] = onFullscreen;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== onOpen || $[7] !== openLabel) {
    t3 = onOpen && openLabel && <ToolbarButton label={openLabel} onClick={stopAndRun(onOpen)}><ArrowTopRightOnSquareIcon className="tw-size-5" aria-hidden="true" /></ToolbarButton>;
    $[6] = onOpen;
    $[7] = openLabel;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = isDownloading ? "Downloading media" : "Download media";
  let t5;
  if ($[9] !== onDownload) {
    t5 = stopAndRun(onDownload);
    $[9] = onDownload;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ArrowDownTrayIcon className="tw-size-5" aria-hidden="true" />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isDownloading || $[13] !== t4 || $[14] !== t5) {
    t7 = <ToolbarButton label={t4} onClick={t5} disabled={isDownloading}>{t6}</ToolbarButton>;
    $[12] = isDownloading;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t2 || $[17] !== t3 || $[18] !== t7) {
    t8 = <div className="tw-flex tw-overflow-hidden tw-rounded-xl tw-bg-iron-900/95 tw-shadow-lg tw-shadow-black/30 tw-ring-1 tw-ring-inset tw-ring-iron-700/70 tw-backdrop-blur">{t2}{t3}{t7}</div>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== onClose) {
    t9 = stopAndRun(onClose);
    $[20] = onClose;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <XMarkIcon className="tw-size-5" aria-hidden="true" />;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t9) {
    t11 = <button type="button" aria-label="Close media" title="Close media" onClick={t9} className="tw-inline-flex tw-size-9 tw-items-center tw-justify-center tw-rounded-xl tw-border-0 tw-bg-iron-900/95 tw-text-iron-100 tw-shadow-lg tw-shadow-black/30 tw-ring-1 tw-ring-inset tw-ring-iron-700/70 tw-backdrop-blur tw-transition tw-duration-200 desktop-hover:hover:tw-bg-iron-700">{t10}</button>;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t8) {
    t12 = <div className="tw-fixed tw-right-4 tw-top-3 tw-z-[1102] tw-flex tw-items-center tw-gap-x-3 tw-pt-[env(safe-area-inset-top,0px)]">{t8}{t11}</div>;
    $[25] = t11;
    $[26] = t8;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
}